export const DOCUTAX_SUBMISSION_STATUS = {
  NEW: 'NEW',
  IN_PROGRESS: 'IN_PROGRESS',
  COMPLETE: 'COMPLETE',
};

const _DOCUTAX_SUBMISSION_STATUS_DESCRIPTION_MAP = {};
_DOCUTAX_SUBMISSION_STATUS_DESCRIPTION_MAP[DOCUTAX_SUBMISSION_STATUS.NEW] = 'New';
_DOCUTAX_SUBMISSION_STATUS_DESCRIPTION_MAP[DOCUTAX_SUBMISSION_STATUS.IN_PROGRESS] = 'In Progress';
_DOCUTAX_SUBMISSION_STATUS_DESCRIPTION_MAP[DOCUTAX_SUBMISSION_STATUS.COMPLETE] = 'Complete';

export const DOCUTAX_SUBMISSION_STATUS_DESCRIPTION_MAP = _DOCUTAX_SUBMISSION_STATUS_DESCRIPTION_MAP;

export default {
  DOCUTAX_SUBMISSION_STATUS,
  DOCUTAX_SUBMISSION_STATUS_DESCRIPTION_MAP,
};
